module.exports = __webpack_public_path__ + "img/type_img03.903e8f79.png";